export default __webpack_public_path__ + "static/media/dog10.401acce0.JPG";